import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { Button, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ProTable, Link, DateDisplay } from 'components/layout';
import { EditButton, DisabledButton } from 'components/button';
import {
  GET_REPORTING_PERIOD,
  TOGGLE_DISABLED_REPORTING_PERIOD,
  GET_CURRENT_REPORTING_PERIOD,
} from 'gql/reportingPeriod';
import { useLoading } from 'hooks';

const ReportingPeriod = () => {
  const { data, loading } = useQuery(GET_REPORTING_PERIOD, {
    variables: { state: 'ALL' },
  });
  const [
    toggleDisabledReportingPeriod,
    { loading: disableLoading },
  ] = useMutation(TOGGLE_DISABLED_REPORTING_PERIOD, {
    refetchQueries: ({
      data: {
        toggleDisabledReportingPeriod: { id },
      },
    }) => [
      { query: GET_REPORTING_PERIOD, variables: { ids: [id], state: 'ALL' } },
      { query: GET_REPORTING_PERIOD },
      { query: GET_CURRENT_REPORTING_PERIOD },
    ],
    onError: (err) => {
      console.log(err);
    },
  });
  const columns = [
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      render: (_) => <DateDisplay date={_} />,
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      render: (_) => <DateDisplay date={_} />,
    },
    {
      title: 'Scheduled Deadline',
      dataIndex: 'scheduledDeadline',
      render: (_) => <DateDisplay date={_} />,
    },
    {
      title: 'Status',
      dataIndex: 'disabled',
      width: 120,
      filters: true,
      onFilter: true,
      valueEnum: {
        false: { text: 'Running', status: 'Success' },
        true: { text: 'Stop', status: 'Error' },
      },
    },
    {
      title: 'Actions',
      width: 200,
      render: (_, item) => (
        <Space size={0}>
          <Link to={`/system-setting/reporting-period/${item.id}`}>
            <EditButton />
          </Link>
          <DisabledButton
            disabled={item.disabled}
            onClick={() => {
              toggleDisabledReportingPeriod({ variables: { id: item.id } });
            }}
          />
        </Space>
      ),
    },
  ];
  useLoading(disableLoading);

  return (
    <PageContainer
      header={{
        title: 'Annual Reporting Period',
        extra: [
          <Button type="primary" key="add">
            <Link to="/system-setting/reporting-period/add">
              <PlusOutlined /> Add
            </Link>
          </Button>,
        ],
      }}
    >
      <ProTable
        loading={loading}
        toolbar={{
          settings: false,
        }}
        toolBarRender={false}
        columns={columns}
        rowKey="id"
        search={false}
        dataSource={data?.reportingPeriods}
        pagination={false}
      />
    </PageContainer>
  );
};

export default ReportingPeriod;
